// angular
//   .module("HeroPRO")
//   .controller("ProductDirectoryController",

import './productDirectory.scss';

/* @ngInject */
export default function ProductDirectoryController($scope, $window, $timeout, $stateParams, productLookupService, categoryCacheService, geoStateCacheService) {
    const vm = this;
    vm.productTypeSearchTerm = null;
    vm.productTypeSearchMinumCharacterCount = 2;
    vm.productTypeSearchResults = null;
    vm.productGeoState = $stateParams.GeoState;
    vm.categories = categoryCacheService.getCategories();

    $scope.$on('productCenter.setupComplete', () => {
        vm.categories = categoryCacheService.getCategories();
    });


    vm.productSearch = function (searchTerm) {
        vm.productTypeSearchTerm = searchTerm;

        const promise = productLookupService.getProductTypeSearch({
            searchTerm,
        });


        return promise.then((response) => {
            if (response.data.SearchResults) {
                vm.productTypeSearchResults = response.data.SearchResults;
                return response.data.SearchResults.map((item) => {
                    item.key = `${item.ProductTypeName} in ${item.CategoryTypeName}`;
                    return item.key;
                });
            }
        }, (reason) => {
            $window.alert(`Get Filters for Search failed: ${reason}`);
        });
    };

    vm.productTypeSearchResultSelect = function ($item) {
        for (let i = 0; i < this.productTypeSearchResults.length; i++) {
            if (this.productTypeSearchResults[i].key === $item) {
                const url = categoryCacheService.getProductTypeUrl(this.productTypeSearchResults[i].ProductTypeId, geoStateCacheService.getCurrentStateObject().StateAbbreviation);
                $window.location = url;
                break;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdirectory/productDirectoryController.js